import * as ReactDOM from "react-dom/client"

export const lwReactCreateRoot = ReactDOM.createRoot